import * as types from '../actions/userSessionsAction';

const initialState = {
  data: [],
  orderDirection: 'DESC',
  sortBy: 'signedInTime',
  limit: '20',
  page: 0,
  totalResults: 0,
  loading: false,
};

const userSessionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_USER_SESSIONS_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.GET_USER_SESSIONS:
      return {
        ...state,
        loading: true,
      };

    case types.GET_USER_SESSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        totalResults: action.payload.length,
      };

    case types.GET_USER_SESSIONS_ERROR:
      return {
        ...state,
        loading: false,
      };

    case types.RESET_USER_SESSIONS_STORE:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default userSessionsReducer;
